// 点击图片跳转
var openPage = function(event){
  let dom = event.target
  let url = event.target.getAttribute('data-href')
  if(url){
    window.location.href = url
  }
}
// 设置顶部高度

var menuL1Container = document.querySelectorAll('#europe-main-nav .container-l1') // 一级导航下的container
// 监听高度，决定#europe-main-nav .container-l1的top
var pageNav = document.querySelector('#europe-main-nav') // 点击展开移动端menu按钮
setTopHeight()
window.addEventListener('resize', function(){
  setTopHeight()
})
function setTopHeight(){
  // 导航高度
  menuL1Container.forEach(element => {
    element.style.top = pageNav.offsetHeight + 'px'
  })
  // toolbar高度
  toolbarHeight = document.querySelector('#europe-toolbar')?.offsetHeight
  document.querySelector('#nav-placeholder').style.height = pageNav.offsetHeight + 'px'
}